import { apiClient } from './client';

export interface Payer {
  id: string;
  name: string;
  /** Счёт компании — не человек: вкладов не делает и прибыль не получает. */
  is_company: boolean;
  /** Доля основателя в прибыли, %. */
  profit_share: number;
  created_at: string;
}

export interface Expense {
  id: string;
  date: string; // YYYY-MM-DD
  title: string;
  description: string | null;
  amount: number;
  payerId: string;
  payer: Payer;
  created_at: string;
  updated_at: string;
}

export interface ExpensesSummary {
  total: number;
  byPayer: Array<{ payerId: string; payerName: string; total: number }>;
}

export interface ExpensesListResponse {
  expenses: Expense[];
  summary: ExpensesSummary;
}

export interface CreateExpenseDto {
  date: string;
  title: string;
  description?: string | null;
  amount: number;
  payerId: string;
}

export type UpdateExpenseDto = Partial<CreateExpenseDto>;

export const expensesApi = {
  getAll: async (): Promise<ExpensesListResponse> => {
    const response = await apiClient.get<ExpensesListResponse>('/expenses');
    return response.data;
  },
  create: async (dto: CreateExpenseDto): Promise<Expense> => {
    const response = await apiClient.post<Expense>('/expenses', dto);
    return response.data;
  },
  update: async (id: string, dto: UpdateExpenseDto): Promise<Expense> => {
    const response = await apiClient.patch<Expense>(`/expenses/${id}`, dto);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/expenses/${id}`);
  },
};

export const payersApi = {
  getAll: async (): Promise<Payer[]> => {
    const response = await apiClient.get<Payer[]>('/payers');
    return response.data;
  },
  create: async (name: string): Promise<Payer> => {
    const response = await apiClient.post<Payer>('/payers', { name });
    return response.data;
  },
  update: async (
    id: string,
    dto: { name?: string; profitShare?: number },
  ): Promise<Payer> => {
    const response = await apiClient.patch<Payer>(`/payers/${id}`, dto);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/payers/${id}`);
  },
};
